function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _Button = require("../Button");
var _View = require("../View");
var _CategoryPills = require("../CategoryPills");
var _SvgImage = require("../SvgImage");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["items", "selectedItems", "emptyMessage", "style"];
var List = exports.List = function List(_ref) {
  var items = _ref.items,
    _ref$selectedItems = _ref.selectedItems,
    selectedItems = _ref$selectedItems === void 0 ? [] : _ref$selectedItems,
    emptyMessage = _ref.emptyMessage,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _hasItems = !!items && items.length > 0;
  var _hasEmptyMessage = !!emptyMessage;
  if (!_hasItems) {
    if (_hasEmptyMessage) {
      return (0, _jsxRuntime.jsx)(_View.View, Object.assign({
        style: [styles.messageContainer, style],
        testID: "List"
      }, props, {
        children: (0, _jsxRuntime.jsx)(_reactNative.Text, {
          style: styles.message,
          children: emptyMessage
        })
      }));
    } else {
      return null;
    }
  }
  return (0, _jsxRuntime.jsx)(_View.View, Object.assign({
    style: [styles.container, style],
    testID: "List"
  }, props, {
    children: _hasItems && items.map(function (item, index) {
      var _isSelected = selectedItems.includes(item.id);
      var _isFirst = index === 0;
      var _isLast = index === items.length - 1;
      var _hasImage = !!item.avatar;
      var _hasTags = !!item.tags && item.tags.length > 0;
      var _hasAction = !!item.actionLabel && !!item.actionOnPress;
      return (0, _jsxRuntime.jsxs)(_react["default"].Fragment, {
        children: [index > 0 && (0, _jsxRuntime.jsx)(_View.View, {
          style: styles.divider
        }), (0, _jsxRuntime.jsxs)(_View.View, {
          style: [styles.listItem, _isSelected && styles.listItem_selected, _isFirst && styles.listItem_first, _isLast && styles.listItem_last],
          children: [!!item.onSelect && (0, _jsxRuntime.jsx)(_Button.Button, {
            type: _Button.ButtonType.blank,
            onPress: function onPress() {
              return item.onSelect == null ? void 0 : item.onSelect(item.id);
            },
            hideLabel: true,
            label: t('list:toggleButtonLabel', {
              name: item.primaryText
            }),
            state: {
              selected: _isSelected,
              checked: _isSelected
            },
            accessibilityRole: "switch",
            textStyle: [styles.toggleButton, _isFirst && styles.toggleButton_first, _isLast && styles.toggleButton_last],
            containerStyle: styles.toggleButtonContainer
          }), _hasImage && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [(0, _jsxRuntime.jsx)(_reactNative.ImageBackground, {
              source: typeof item.avatar === 'string' ? {
                uri: item.avatar
              } : {},
              style: styles.imageContainer,
              imageStyle: styles.image,
              testID: "ListItemImage",
              children: _typeof(item.avatar) === _typeof(_SvgImage.SvgImage) && (0, _jsxRuntime.jsx)(item.avatar, {
                style: styles.image,
                testID: "ListItemImageSvg"
              })
            }), (0, _jsxRuntime.jsx)(_View.View, {
              style: styles.spacer
            })]
          }), (0, _jsxRuntime.jsxs)(_View.View, {
            style: styles.textContainer,
            children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
              style: styles.primaryText,
              children: item.primaryText
            }), !!item.secondaryText && (0, _jsxRuntime.jsx)(_reactNative.Text, {
              style: styles.secondaryText,
              children: item.secondaryText
            })]
          }), !!item.tertiaryText && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [(0, _jsxRuntime.jsx)(_View.View, {
              style: styles.spacer
            }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
              style: styles.tertiaryText,
              children: item.tertiaryText
            })]
          }), _hasTags && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [(0, _jsxRuntime.jsx)(_View.View, {
              style: styles.spacer
            }), (0, _jsxRuntime.jsx)(_CategoryPills.CategoryPills, {
              categoryPills: item.tags,
              style: styles.tagsContainer
            })]
          }), _hasAction && (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [(0, _jsxRuntime.jsx)(_View.View, {
              style: styles.spacer
            }), (0, _jsxRuntime.jsx)(_Button.Button, {
              ariaLabel: "".concat(item.actionLabel, " ").concat(item.primaryText),
              label: item.actionLabel,
              onPress: item.actionOnPress,
              type: _Button.ButtonType.link,
              textStyle: styles.action,
              containerStyle: styles.actionContainer
            })]
          })]
        })]
      }, "listItem-".concat(item.id));
    })
  }));
};